import { types } from './types';


const INITIAL_STATE = {
  variables : {},
  permissions : {},
};

const reducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case types.UPDATE_FORM_FIELD:
      return {
        ...state,
        [payload.group]: {
          ...state[payload.group],
          [payload.key]: payload.value,
        },
      };
    case types.GET_PROCESS_INSTANCES_APP.SUCCESS:
      return {
        ...state,
        variables: payload.variables,
        resultSize: payload.resultSize,
        activeTaskName: payload.activeTaskName,
        applStatus: payload.variables.applStatus,
        loadingApptrack: false,
      };
      case types.GET_PROCESS_INSTANCES_APP.START:
        return {
          ...state,
          loadingApptrack: true,
        };
      case types.GET_PROCESS_INSTANCES_APP.ERROR:
        return {
          ...state,
          loadingApptrack: false,
        };  
    case types.GET_FORM_DATA_APP.SUCCESS:
      return {
        ...state,
        variables: payload.variables,
      };
    case types.GET_TASK_DATA.SUCCESS:
      return {
        ...state,
        task: {
          ...state.task,
          ...payload,
        },
      };
      case types.FETCH_PROCESS_SAYT.SUCCESS:
        return {
          ...state,
          sayt: payload,
        };
      case types.CLEAR_SAYT:
          return {
            ...state,
            sayt: {},
          };
    case types.GET_ACTIONS.SUCCESS:
      return {
        ...state,
        permissions: {
          ...state.permissions,
          ...payload,
        },
      };
    case types.CLEAR_APPTRACK.SUCCESS:
        return INITIAL_STATE;
    case types.GET_OFFERS_HISTORY.SUCCESS:
      return {
        ...state,
        offersHistory: payload
      };
    case types.GET_PROVIDER_HISTORY.SUCCESS:
      return {
        ...state,
        providersHistory: payload.providerUploads
      };
    case types.GET_ACTIVE_OFFERS.SUCCESS:
      return {
        ...state,
        activeOffers: payload
      };
    case types.CLEAR_ACTIVE_OFFERS.SUCCESS:
        return {
          ...state,
          activeOffers: payload
        };
    case types.OPEN_UPLOAD_OFFERS_MODAL.SUCCESS:
      return {
        ...state,
        openOffersModal: payload
      };
    case types.OPEN_UPLOAD_PROVIDER_MODAL.SUCCESS:
      return {
        ...state,
        openProviderModal: payload
      };
    case types.SET_SELECTED_OFFERS_FILE.SUCCESS:
      return {
        ...state,
        selectedOffersFile: payload
      };
    case types.SET_SELECTED_PROVIDER_FILE.SUCCESS:
      return {
        ...state,
        selectedProviderFile: payload
      };
    case types.GET_APPTRACK_DETAILS.SUCCESS:
      return {
        ...state,
        apptrackDetails: payload,
        loading: false
      };
    case types.SET_APPTRACK_LOADING:
      return {
        ...state,
        loading: true
      };
    case types.GET_ALL_TASK_NAMES.SUCCESS:
        return {
          ...state,
          taskNames: payload.map(name => ({ name })),
        }
    default:
      return state;
  }
};

export default reducer;
